import { render, staticRenderFns } from "./AboutPageHeadline.vue?vue&type=template&id=9097ecac&scoped=true&"
import script from "./AboutPageHeadline.vue?vue&type=script&lang=js&"
export * from "./AboutPageHeadline.vue?vue&type=script&lang=js&"
import style0 from "./AboutPageHeadline.vue?vue&type=style&index=0&id=9097ecac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9097ecac",
  null
  
)

export default component.exports